import type { GroupBase, StylesConfig } from "react-select";

export * from "./batch_register.constants";
export * from "./edit-drivers.constants";
export * from "./list-drivers.constants";

export const DRIVERS_PAGE_SIZE = 10;
export const CNH_STATUS_PAGE_SIZE = 5;
export const CATEGORY_OPTIONS = ["A", "B", "C", "D", "E"];

export const SELECT_STYLES: StylesConfig<
	{ value: string; label: string },
	true,
	GroupBase<{ value: string; label: string }>
> = {
	control: (base, state) => ({
		...base,
		backgroundColor: "var(--color-bg-primary)",
		borderColor: state.isFocused
			? "var(--color-border-brand)"
			: "var(--color-border-primary)",
		borderRadius: "8px",
		minHeight: "36px",
		maxHeight: "36px",
		minWidth: "180px",
	}),
	valueContainer: (base) => ({
		...base,
	}),
	option: (base, { isFocused, isSelected }) => ({
		...base,
		backgroundColor: isFocused || isSelected ? "#e5e7eb" : "#ffffff",
		color: "#111827",
	}),
	multiValue: (base) => ({
		...base,
		backgroundColor: "#e5e7eb",
	}),
	multiValueLabel: (base) => ({
		...base,
		color: "#111827",
	}),
};
